module.exports = __webpack_public_path__ + "img/spring_trip-20160416-13.04cfa87e.jpg";